module.exports = __webpack_public_path__ + "assets/img/tx113.602650c6.jpg";